<template>
  <div>
    <div v-if="!isOneVariable">
      <u>{{ label }}</u>
    </div>
    <span> {{ value }} </span>
  </div>
</template>

<script>
export default {
  name: 'RecruiterIcoCriteriaResultTypeRating',
  props: {
    jobQuestion: {
      type: Object,
      required: true,
    },
    variable: {
      type: Object,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    isOneVariable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    label: function () {
      return this.variable.short_label || this.variable.input_label;
    },
  },
};
</script>

<style scoped />
